import type { ApiProduct } from '@/types/api';
import type { Product } from '@/types';
import { storageUrl } from './config';

export function apiProductToProduct(api: ApiProduct): Product {
  const placeholder = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="600" height="800" viewBox="0 0 600 800"><rect fill="#F5EDE7" width="600" height="800"/><text fill="#999" font-family="Arial" font-size="24" text-anchor="middle" x="300" y="400">${api.name}</text></svg>`)}`;

  const mainImage = api.images && api.images.length > 0
    ? storageUrl(api.images[0].image_path)
    : placeholder;

  const allImages = api.images && api.images.length > 0
    ? api.images.map(img => storageUrl(img.image_path))
    : [mainImage];

  return {
    id: String(api.id),
    name: api.name,
    slug: api.slug || `product-${api.id}`,
    category: api.category?.name || '',
    price: api.price,
    oldPrice: api.discount > 0 ? api.price + (api.price * api.discount / 100) : undefined,
    image: mainImage,
    images: allImages,
    rating: 4.5,
    reviewCount: 0,
    badge: api.is_featured ? 'مميز' : undefined,
    description: api.description || '',
    benefits: api.benefits ? [api.benefits] : [],
    ingredients: api.ingredients || '',
    howToUse: api.how_to_use || '',
    inStock: api.is_active_for_sale && api.quantity > 0,
    stockQuantity: api.quantity || 0,
    sku: api.sku || `SA-${api.id}`,
    variants: undefined,
    videoUrl: api.video || undefined,
  };
}
